import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/tradesy-restricted-items';

export default function Example() {
  return (
    <>
      <Head>
        <title>Tradesy Restricted Items: Keep These Off Your List</title>
        <meta
          name='description'
          content='Learn restricted items on Tradesy, including what not to sell, how to ensure authenticity, and tools to use to win more customers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/tradesy-restricted-items' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/tradesy-restricted-items' />
        <meta property='og:title' content='Tradesy Restricted Items: Keep These Off Your List' />
        <meta
          property='og:description'
          content='Learn restricted items on Tradesy, including what not to sell, how to ensure authenticity, and tools to use to win more customers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-20T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-20T00:00:00-00:00' />
        <meta property='article:tag' content='Tradesy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
